'use client';

import { cn } from '@insta-club/utilities';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

function LoadingLayer({ show }: { show: boolean }) {
    return (
        <>
            <div
                className={cn(
                    'fixed top-0 z-[99999] flex h-full w-full max-w-[var(--container-max)] items-center justify-center bg-white/95 backdrop-blur-md transition-opacity duration-500',
                    show ? 'opacity-100' : 'pointer-events-none opacity-0'
                )}
            >
                <div
                    style={{
                        width: 230,
                        height: 230
                    }}
                >
                    <DotLottieReact src='/assets/lottie/loading.json' loop autoplay />
                </div>
            </div>
        </>
    );
}

export default LoadingLayer;

